import { useQuery } from "@tanstack/react-query";
import { http } from "../../../utils/httpCommon";
import {
  Section,
  sectionsSchema,
} from "../../../services/prePlanningService.types";
import { useApiUrls } from "../../useApiUrl";

const sectionsQueryKey = (sicId: number) => ["pre-planning", sicId, "sections"];

type GetSectionsResponse = Omit<Section, "shipmentIds"> &
  {
    shipmentsIds: number[];
  }[];

export function useSections(destinationSicId: number) {
  const hookUrls = useApiUrls();
  const { getSections } = hookUrls;

  const getSectionsData = async (
    destinationSicId: number
  ): Promise<Section[]> => {
    const url = getSections(destinationSicId);
    const { status, data } = await http.get<GetSectionsResponse>(url);

    if (status === 204) return [];

    return sectionsSchema.parse(data);
  };

  return useQuery({
    queryKey: sectionsQueryKey(destinationSicId),
    queryFn: () => getSectionsData(destinationSicId),
  });
}
